export default {
    DAY: 'dateOfBirthDay',
    MONTH: 'dateOfBirthMonth',
    YEAR: 'dateOfBirthYear',
};
